import React from 'react'

import { Box, Typography, TextField } from '@material-ui/core'
import moment from 'moment'
import helpers from 'helpers'

import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmarkOutlined'

const DisplayInvoicePlan = ({ plans }) => {
  const formatPrice = plan => {
    if (plan.typeEntry === 'discount' && plan.price > 0) {
      return `R$ -${helpers.currency(plan.price, { hideSymbol: true })}`
    }
    return helpers.currency(plan.price || plan.plan?.price)
  }

  return (
    <>
      <Box display="flex" alignItems="center">
        <Box mr={4}>
          <CollectionsBookmarkIcon fontSize="large" color="disabled" />
        </Box>
        <Box>
          <Typography variant="h5" color="textSecondary">
            Plano
          </Typography>
        </Box>
      </Box>
      {plans.map((plan, index) => (
        <Box
          display="flex"
          flexGrow={1}
          flexDirection={{
            xs: 'column',
            sm: 'row',
          }}
          key={index}
          mb={3}
        >
          <Box flex={1} mr={6}>
            <TextField
              margin="dense"
              label="Plano"
              value={plan.plan?.name || plan.description}
              variant="outlined"
              fullWidth
              disabled
            />
            {plan.plan && (
              <TextField
                margin="dense"
                label="Data de vencimento"
                value={plan.from ? moment(plan.from).format('DD/MM/YYYY') : ''}
                variant="outlined"
                fullWidth
                disabled
              />
            )}
          </Box>
          <Box flex={1} mr={6}>
            <TextField
              margin="dense"
              label="Valor"
              value={formatPrice(plan)}
              variant="outlined"
              fullWidth
              disabled
            />
            {plan.plan && (
              <TextField
                margin="dense"
                label="Data de fim da vigencia"
                value={plan.from ? moment(plan.till).format('DD/MM/YYYY') : ''}
                variant="outlined"
                fullWidth
                disabled
              />
            )}
          </Box>
        </Box>
      ))}
    </>
  )
}

export default DisplayInvoicePlan
